import devConfig from '../config/values/dev.json.js';
import prodConfig from '../config/values/prod.json.js';
import defaultConfig from '../config/values/default.json.js';
import commonConfig from '../config/values/common.json.js';

/*
 *  The default configuration is the one common to all environments. In particular, it holds enough information to initialize a SentryService.
 */
function getDefaultConfig() {
    return {
        appVersion: '5.20.0',
        ...defaultConfig,
    };
}
const isBrowser = () => typeof window !== 'undefined';
const selectConfig = (env) => {
    if (isBrowser() && !window.Payment)
        window.Payment = {};
    return (shopBundle = 'zooplus') => {
        const envConfig = env === 'prod' ? prodConfig : devConfig;
        const mergedShopConfig = {
            ...commonConfig[shopBundle],
            ...envConfig.shopCommon,
            ...envConfig[shopBundle],
        };
        const config = { env, ...getDefaultConfig(), ...mergedShopConfig };
        if (isBrowser())
            window.Payment.__APP_RUNNING_CONFIG__ = config;
        return config;
    };
};

export { getDefaultConfig, selectConfig };
//# sourceMappingURL=configUtils.js.map
